var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCallOffOrderMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.60002 15.4667C6.26277 15.4667 6.80002 14.9294 6.80002 14.2667C6.80002 13.6039 6.26277 13.0667 5.60002 13.0667C4.93728 13.0667 4.40002 13.6039 4.40002 14.2667C4.40002 14.9294 4.93728 15.4667 5.60002 15.4667Z",
    stroke: "#C9E8FB",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8 15.4667C13.4627 15.4667 14 14.9294 14 14.2667C14 13.6039 13.4627 13.0667 12.8 13.0667C12.1372 13.0667 11.6 13.6039 11.6 14.2667C11.6 14.9294 12.1372 15.4667 12.8 15.4667Z",
    stroke: "#C9E8FB",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.47035 14.6667H3.99995C3.55812 14.6667 3.19995 14.3085 3.19995 13.8667V11.4949C3.19997 11.2275 3.33366 10.9777 3.55622 10.8293L4.24955 10.3664C4.34805 10.3007 4.43075 10.214 4.49168 10.1125L5.36635 8.65494C5.51162 8.41292 5.77368 8.26537 6.05595 8.26667H7.14715C7.42809 8.26669 7.68843 8.41406 7.83302 8.65494L10.0026 12.2667",
    stroke: "#C9E8FB",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.17383 6.62027L11.9504 11.5168",
    stroke: "#C9E8FB",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2 6.66667L13.7061 10.8432",
    stroke: "#C9E8FB",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.73169 14.6667H11.6688",
    stroke: "#C9E8FB",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.40002 5.86667H7.75789C7.91583 5.86669 8.07022 5.91345 8.20162 6.00107L8.99896 6.5344C9.13036 6.62202 9.28476 6.66878 9.44269 6.6688H12.7296C13.0202 6.6689 13.2878 6.82651 13.4288 7.08054L14.9952 9.89974C15.1237 10.1306 15.1299 10.4101 15.0118 10.6464L13.6326 13.4043",
    stroke: "#C9E8FB",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.02295 13.0091C9.12428 12.6128 15.0955 10.3072 15.0955 10.3072",
    stroke: "#C9E8FB",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.80005 10.6667H9.04005",
    stroke: "#C9E8FB",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M6.42932 1.20694H7.62932",
    stroke: "#C9E8FB",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M9.22937 1.20694C9.6712 1.20694 10.0294 1.56511 10.0294 2.00694",
    stroke: "#C9E8FB",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0293 3.60693V4.80693",
    stroke: "#C9E8FB",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M3.02935 2.80693C3.02935 2.69648 2.9398 2.60693 2.82935 2.60693",
    stroke: "#C9E8FB",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M2.82935 3.00693C2.9398 3.00693 3.02935 2.91739 3.02935 2.80693",
    stroke: "#C9E8FB",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M2.62927 2.80693C2.62927 2.91739 2.71882 3.00693 2.82927 3.00693",
    stroke: "#C9E8FB",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M2.82927 2.60693C2.71882 2.60693 2.62927 2.69648 2.62927 2.80693",
    stroke: "#C9E8FB",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.82932 0.406937C4.1548 0.406937 5.22932 1.48145 5.22932 2.80694C5.22932 3.83147 3.79572 5.7808 3.14452 6.61387C3.06871 6.71089 2.95245 6.7676 2.82932 6.7676C2.70619 6.7676 2.58993 6.71089 2.51412 6.61387C1.86292 5.78134 0.429321 3.83147 0.429321 2.80694C0.429321 1.48145 1.50384 0.406937 2.82932 0.406937V0.406937Z",
    stroke: "#C9E8FB",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCallOffOrderMenu);
export default __webpack_public_path__ + "static/media/ic-call-off-order-menu.051d7bda1880e636309150a9ee749f7c.svg";
export { ForwardRef as ReactComponent };